export const DAO_CODE = 'TRAINING_OBJECTIVE' + '_DAO';
